import { PaginatedResponse } from '@frontend/api-utils';

import { DocumentInfo } from './question';


export interface Answer {
    answer: string;
    answer_nl_be: string | null;
    answer_en_us: string | null;
    answer_fr_fr: string | null;
    answer_de_de: string | null;
    sorting: number | null;
    illustration: DocumentInfo;
    image_or_video: DocumentInfo;
    result: AnswerResult;
    update_timestamp: string;
    id: string;
    account_id: string;
    question_id: string;
    creation_timestamp: string;
}

export interface CreateAnswer {
    answer?: string;
    answer_nl_be?: string | null;
    answer_en_us?: string | null;
    answer_fr_fr?: string | null;
    answer_de_de?: string | null;
    sorting?: number | null;
    result?: AnswerResult | null;
}

export interface UpdateAnswer {
    answer?: string;
    answer_nl_be?: string | null;
    answer_en_us?: string | null;
    answer_fr_fr?: string | null;
    answer_de_de?: string | null;
    sorting?: number | null;
    result?: AnswerResult | null;
}

export interface CreateAnswerFile {
    image_or_video_file?: File | null;
}

export enum AnswerResult {
    CONTINUE_WITH_VENDING = 'continue_with_vending',
    ABORT = 'abort',
    SHOW_IMAGE = 'show_image'
}

export type AnswerListResponse = PaginatedResponse<Answer>;

export enum AnswerQueryParams {
    ACCOUNT_ID = 'account_id',
    QUESTION_ID = 'question_id',
    ANSWER_ID = 'answer_id'
}
